import imageOne from '@/assets/images/cities/calgary1.jpg'
import imageTwo from '@/assets/images/cities/calgary2.jpg'
import imageThree from '@/assets/images/cities/calgary3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Calgary',
  writeup: `We offer Calgary’s premier Notary Public and Commissioner for Oaths services at reasonable prices. Our services are provided by trusted and respected lawyers who are members of the Law Society of Alberta. From certified copies to attestations, we offer a wide variety of services to meet your needs.
<br><br>All Notary Services are by appointment only.  Call us today to book a time to see us!
<br><br>Any questions or concerns? Give us a call, our staff are ready to help! We take pride in our friendly service and work diligently to meet your needs.
<br><br>We have two office locations available to help serve you better! Mobile services are also available on evenings and weekends! Please call us to learn more.`,
  website: 'MyCalgaryNotaryPublic.com',
  url: 'https://www.mycalgarynotarypublic.com/',
  notaries: [
    {
      name: 'Calgary Northeast',
      open: true,
      phone: '(587) 774-9375',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'Westwinds Crescent NE Location',
      notes: 'No Power of Attorneys.'
    },
    {
      name: 'Calgary Southwest',
      open: true,
      phone: '(587) 774-9375',
      hours: {
        monday: '10:00AM to 5:00PM',
        tuesday: '10:00AM to 5:00PM',
        wednesday: '10:00AM to 5:00PM',
        thursday: '10:00AM to 5:00PM',
        friday: '10:00AM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: '441 - 5th Avenue SW Location',
      notes: 'No Power of Attorneys.'
    },
    {
      name: 'Calgary Mobile Service',
      open: true,
      phone: '(587) 774-9375',
      hours: {
        monday: '6:00PM to 9:00PM',
        tuesday: 'Closed',
        wednesday: '6:00PM to 9:00PM',
        thursday: 'Closed',
        friday: '6:00PM to 9:00PM',
        saturday: 'Closed',
        sunday: '2:30PM to 9:00PM'
      },
      address: 'Available anywhere in Calgary and the surrounding communities.',
      notes:
        'Our notary comes to you to provide convenient, expedient, and comprehensive service. No Power of Attorneys.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/alberta/cities/calgary.js